module.exports = __webpack_public_path__ + "static/media/italy.70de7650.jpg";